import KomunikatorContext from "Components/KomunikatorContext/KomunikatorContext";

const KomunikatorConsumer = KomunikatorContext.Consumer;

export default KomunikatorConsumer;